import { createContext } from 'react';

const initialState = {
  editor_expanded: true,
  show_chat_widget: false,
  plan_name: "no_plan",
  plan: null,
  plan_limits: null,  // { plan_name, responses, links, api_keys, workspaces, members } — fetched on mount
  billing_subscription: null,
  other_plans_name: [],
  other_plans: [],
  loading: true,
  visitor_id: localStorage.getItem('visitor_id') || null,
  header_content: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.payload };
    case 'LOAD_DATA':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

const isSubscribed = (state) => {
  return state.plan_name && state.plan_name != "no_plan";
}

const isSubscribedAny = (state) => {
  const { plan_name, other_plans_name } = state;

  const isMainPlanSubscribed = plan_name && plan_name !== "no_plan";

  const hasValidOtherPlans = Array.isArray(other_plans_name) &&
    other_plans_name.length > 0 &&
    !other_plans_name.includes("no_plan");

  return isMainPlanSubscribed || hasValidOtherPlans;
};

const isPlanLoaded = (state) => {
  const { plan_name, plan, other_plans_name } = state;
  return plan_name || other_plans_name.length > 0
}


const StoreContext = createContext();

export {
  initialState, reducer, isPlanLoaded, isSubscribed, isSubscribedAny,
  StoreContext
};
